import { ChecklistProgress } from "./ChecklistProgress";
import { CheckSquare, ChevronRight, PencilIcon } from "lucide-react";
import { cn } from "@/modern/utils";
import { Checklist } from "@/bryntum-lib/models/Checklist";
import { useEntityChecklistContext } from "../context/EntityChecklistContext";

interface ChecklistListProps {
  checklists: Checklist[];
  onShowDetails: (checklist: Checklist) => void;
}

export const ChecklistList = ({ checklists, onShowDetails }: ChecklistListProps) => {
  const { canEditChecklist, isUserAssignedToChecklist } = useEntityChecklistContext();
  return checklists.map((checklist) => {
    return (
      <button
        key={checklist.id}
        onClick={() => onShowDetails(checklist)}
        className={cn(
          "group w-full p-4 bg-card rounded-lg border border-border/70 text-left mt-3 first:mt-0 transition-all duration-200 hover:border-primary/60 hover:bg-primary/5",
          checklist.archived && "line-through"
        )}
      >
        <div className="flex items-start gap-2">
          <div className="p-1 rounded-md bg-primary/20 text-primary shrink-0">
            <CheckSquare className="size-4" />
          </div>
          <div className="flex-1 min-w-0 space-y-3">
            <div className="flex items-center justify-between gap-2">
              <h4 className="flex items-center gap-2 font-medium text-foreground/95 truncate text-sm">
                {checklist.title || "Untitled Checklist"}
                {canEditChecklist(checklist) || isUserAssignedToChecklist(checklist) && (
                  <PencilIcon className="size-3" />
                )}
              </h4>
              <ChevronRight className="w-3 h-3 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
            </div>
            <ChecklistProgress checklist={checklist} barContainerClassName="h-1.5" textClassName="text-xs" />
          </div>
        </div>
      </button>
    );
  });
};
